import { defineStore } from 'pinia'
import { fetchCurrency } from '@/lib/currency/index.js'

export const useCurrencyStore = defineStore('currency', {
  state: () => ({
    currencyValues: {
        usd: {
            value: 0,
            factor: 0,
            gap: 0,
            finalValue: 0,
            factorWithGap: 0,
        },
        cop: {
            value: 0,
            factor: 0,
            gap: 0,
            finalValue: 0,
            factorWithGap: 0,
        },
        eur: {
            value: 0,
            factor: 0,
            gap: 0,
            finalValue: 0,
            factorWithGap: 0,
        },
        brl: {
            value: 0,
            factor: 0,
            gap: 0,
            finalValue: 0,
            factorWithGap: 0,
        },
    },
  }),

  actions: {
    async getCurrencyValues() {
     const currencyValues = await fetchCurrency()
     // this.currencyValues.USD  = currencyValues.USD || this.currencyValues.USD
     this.currencyValues.usd_cop  = currencyValues.usd_cop || this.currencyValues.usd_cop
     this.currencyValues.usd_eur  = currencyValues.usd_eur || this.currencyValues.usd_eur
     this.currencyValues.usd_brl  = currencyValues.usd_brl || this.currencyValues.usd_brl

    }
  },
  persist: true
})
